import React from 'react';
import { BookOpen, CheckSquare, MessageSquare } from 'lucide-react';
export function Features() {
  const features = [{
    icon: BookOpen,
    title: '1. PDF Principal (Reset de 14 días)',
    items: ['Guía día por día', '2 rituales diarios (mañana/noche)', 'Micro-retos de 2–5 minutos', 'Reparación rápida para roces', 'Escalera de intimidad sin presión']
  }, {
    icon: CheckSquare,
    title: '2. Workbook Imprimible',
    items: ['Checklist diario de progreso', 'Notas rápidas de observación', 'Medición Día 0 vs Día 14', 'Registro de victorias pequeñas']
  }, {
    icon: MessageSquare,
    title: '3. Tarjetas Recortables (Scripts)',
    items: ['Guiones de inicio suave', 'Reparación en 2 minutos', 'Pedido de conexión claro (sin indirectas)', 'Preguntas para romper el hielo']
  }];
  return <section className="py-12 md:py-16 bg-charcoal-900" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-cream-100 mb-12" data-id="element-22">
          Qué incluye exactamente
        </h2>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-23">
          {features.map((feature, idx) => <div key={idx} className="bg-charcoal-800 rounded-xl overflow-hidden border border-charcoal-700 flex flex-col" data-id="element-24">
              <div className="p-6 bg-charcoal-700/50 border-b border-charcoal-700 flex items-center gap-3" data-id="element-25">
                <feature.icon className="w-6 h-6 text-amber-400" data-id="element-26" />
                <h3 className="font-serif text-lg text-cream-100 font-medium" data-id="element-27">
                  {feature.title}
                </h3>
              </div>
              <div className="p-6 flex-1" data-id="element-28">
                <ul className="space-y-3" data-id="element-29">
                  {feature.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-cream-200/80 text-sm" data-id="element-30">
                      <span className="w-1.5 h-1.5 rounded-full bg-amber-400/50 mt-1.5 flex-shrink-0" data-id="element-31" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}